import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BrowserService {
    getNavigatorReference(): any {
        return navigator;
    }

    isIphone() {
        const nav = this.getNavigatorReference();

        return !!nav.platform && /iPhone/.test(nav.platform);
    }

    isEdge() {
        const nav = this.getNavigatorReference();

        return nav.userAgent.indexOf('Edge') > -1;
    }

    isAndroid() {
        const nav = this.getNavigatorReference();

        return nav.userAgent.toLowerCase().indexOf('android') > -1;
    }

    isIE() {
        const nav = this.getNavigatorReference();

        return /msie\s|trident\//i.test(nav.userAgent);
    }

    isAppleMobileDevice(): boolean {
        const navigator = this.getNavigatorReference();

        return !!navigator.platform && /iPad|iPhone/.test(navigator.platform);
    }

    isSafari(): boolean {
        const nav = this.getNavigatorReference();

        return /Version\/(\S+).*?Safari\//i.test(nav.userAgent);
    }

    isAppleDevice(): boolean {
        return this.isAppleMobileDevice() || this.isSafari();
    }

    isAppleDeviceWithIos13plus(): boolean {
        const nav = this.getNavigatorReference();

        return (this.isAppleDevice() && nav.maxTouchPoints > 1);
    }

    isMobileDevice(): boolean {
        const nav = this.getNavigatorReference();

        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS\//i.test(nav.userAgent);
    }

    isTabletDevice(): boolean {
        const nav = this.getNavigatorReference();

        return /Tablet|iPad|iPod/i.test(nav.userAgent);
    }

    isOrientationPortrait() {
        return window.matchMedia('(orientation: portrait)').matches;
    }
}
